import { enUS, es, pt, type Locale } from 'date-fns/locale';

import { I18nLocale } from '#/i18n/types/I18nLocale';

export const DATE_FNS_LOCALE_BY_LOCALE = {
  [I18nLocale.EN]: enUS,
  [I18nLocale.ES]: es,
  [I18nLocale.PT]: pt,
} satisfies Record<I18nLocale, Locale>;

export function getDateFnsLocale(locale: I18nLocale) {
  return DATE_FNS_LOCALE_BY_LOCALE[locale];
}

export function getLocaleCode(locale: I18nLocale) {
  return getDateFnsLocale(locale).code;
}
